import useSWR from "swr";
import { Tab } from "./index";
import ReactJson from "react-json-view";
import apiClient from "../../../apiClient";

const fetcher = async (endpoint: string) => {
    try {
        const res = await apiClient.get(endpoint);
        return res.data;
    } catch (err) {
        return [];
    }
}

export default function UnitedLogs ({
    tab
}: {
    tab: Tab
}) {
    const endpoint = tab === 'UNITED_API' ? '/dev/logs/united' : null;
    const {
        data
    } = useSWR(endpoint, fetcher);

    return (
        <ReactJson 
            src={data}
            displayDataTypes={false}
        />
    );
}